module.exports = __webpack_public_path__ + "img/9788996582489.cbf34f18.jpg";